(() => {
  const CART_ADD_PATH = /\/cart\/add(?:\.js)?(?:[?#]|$)/;
  const OPEN_SUPPRESSION_MS = 800;
  const DISPLAY_MS = 3200;
  const IMAGE_WAIT_MS = 600;

  class AjaxCartSuccessToast extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.message = this.querySelector('.ajax-cart-success-toast__message');
      this.productTitle = this.querySelector('.ajax-cart-success-toast__product-title');
      this.imageWrap = this.querySelector('.ajax-cart-success-toast__image-wrap');
      this.image = this.querySelector('.ajax-cart-success-toast__image');
      this.closeButton = this.querySelector('.ajax-cart-success-toast__close');
      this.closeButton.addEventListener('click', () => this.hide());
      this.renderSequence = 0;
      this.addEventListener('click', (event) => {
        if (event.target.closest('.ajax-cart-success-toast__close')) return;
        const cart = document.querySelector('cart-notification, cart-drawer');
        this.hide();
        if (cart && typeof cart.open === 'function') cart.open();
      });
      document.addEventListener('cart:added', (event) => this.show(event.detail));
    }

    show(detail) {
      window.clearTimeout(this.timer);
      const renderId = ++this.renderSequence;
      const item = detail && (detail.item || (detail.items && detail.items[0]) || detail);
      const title = item && (item.product_title || item.title);
      const featuredImage = item && item.featured_image;
      const image = item && (
        (typeof item.image === 'string' && item.image) ||
        (item.image && (item.image.url || item.image.src)) ||
        (typeof featuredImage === 'string' && featuredImage) ||
        (featuredImage && (featuredImage.url || featuredImage.src))
      );

      // Never leave the previous product visible while the next image is loading.
      this.removeAttribute('open');
      this.setAttribute('aria-hidden', 'true');
      this.imageWrap.hidden = true;
      this.image.removeAttribute('src');
      this.image.alt = '';
      this.productTitle.textContent = '';
      this.productTitle.hidden = true;

      if (!image) {
        this.render({ renderId, title });
        return;
      }

      const preloadedImage = new Image();
      let settled = false;
      const imageWaitTimer = window.setTimeout(() => finish(), IMAGE_WAIT_MS);

      const finish = (loadedImage) => {
        if (settled) return;
        settled = true;
        window.clearTimeout(imageWaitTimer);
        this.render({ renderId, title, image: loadedImage });
      };

      preloadedImage.onload = () => finish(image);
      preloadedImage.onerror = () => finish();
      preloadedImage.src = image;
    }

    render({ renderId, title, image }) {
      // A slower, older request must never replace the latest product.
      if (renderId !== this.renderSequence) return;

      this.message.textContent = this.dataset.message;
      this.productTitle.textContent = title || '';
      this.productTitle.hidden = !title;
      this.imageWrap.hidden = !image;
      if (image) {
        this.image.src = image;
        this.image.alt = title || '';
      }
      this.removeAttribute('open');
      void this.offsetWidth;
      this.setAttribute('open', '');
      this.setAttribute('aria-hidden', 'false');
      this.timer = window.setTimeout(() => this.hide(), DISPLAY_MS);
    }

    hide() {
      window.clearTimeout(this.timer);
      this.removeAttribute('open');
      this.setAttribute('aria-hidden', 'true');
    }
  }

  if (!customElements.get('ajax-cart-success-toast')) customElements.define('ajax-cart-success-toast', AjaxCartSuccessToast);

  function suppressNextCartOpen() {
    const cart = document.querySelector('cart-notification, cart-drawer');
    if (!cart || cart.dataset.ajaxCartOpenPatched === 'true' || typeof cart.open !== 'function') return;
    const originalOpen = cart.open.bind(cart);
    cart.dataset.ajaxCartOpenPatched = 'true';
    cart.open = function () {
      if (this._ajaxCartSuppressOpenUntil && Date.now() < this._ajaxCartSuppressOpenUntil) {
        this._ajaxCartSuppressOpenUntil = 0;
        return;
      }
      return originalOpen();
    };
  }

  document.addEventListener('cart:added', () => {
    suppressNextCartOpen();
    const cart = document.querySelector('cart-notification, cart-drawer');
    if (cart) cart._ajaxCartSuppressOpenUntil = Date.now() + OPEN_SUPPRESSION_MS;
  });

  // A genuine click on the cart control must always win over an in-flight add.
  document.addEventListener('click', (event) => {
    if (!event.target.closest('#cart-icon-bubble')) return;
    const cart = document.querySelector('cart-notification, cart-drawer');
    if (cart) cart._ajaxCartSuppressOpenUntil = 0;
  }, true);

  const nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input && input.url;
    if (!url || !CART_ADD_PATH.test(url)) return nativeFetch(input, init);

    document.dispatchEvent(new CustomEvent('cart:add:request'));

    return nativeFetch(input, init).then((response) => {
      return response.clone().json().catch(() => null).then((payload) => {
        const failed = !response.ok || !payload || payload.errors || Number(payload.status) >= 400;
        if (failed) {
          const message = payload && (payload.description || payload.message);
          document.dispatchEvent(new CustomEvent('cart:add:error', { detail: { message } }));
        } else {
          document.dispatchEvent(new CustomEvent('cart:added', { detail: payload }));
        }
        return response;
      });
    }).catch((error) => {
      document.dispatchEvent(new CustomEvent('cart:add:error', { detail: { message: error && error.message } }));
      throw error;
    }).finally(() => {
      document.dispatchEvent(new CustomEvent('cart:add:complete'));
    });
  };
})();
